import { render } from "./BCPGenerate.vue?vue&type=template&id=e023bdec"
import script from "./BCPGenerate.vue?vue&type=script&lang=js"
export * from "./BCPGenerate.vue?vue&type=script&lang=js"

import "./BCPGenerate.vue?vue&type=style&index=0&id=e023bdec&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__